module.exports = __webpack_public_path__ + "static/media/ic_tick.efa1c9ce.svg";